<template>
    <div class="container-fluid position-relative bg-BAT">
        <div v-if="combinateData === null">
            <loading></loading>
        </div>
        <div>
            <div class="container watch-container py-4">
                <div>
                    <div class="breadcrumbs-retos d-flex flex-column pb-2">
                        <div>
                            <a href="/home-bat">
                                <img src="/img/icons/homeBread.svg" alt="" />
                                Home
                            </a>
                            <a id="practica" class="link cursor-pointer link-active-bread"
                               href="/home-bat">Staff</a>
                            <span id="optionP" class="d-none color-active-miga"></span>
                        </div>
                    </div>
                    <a class="pb-2 pt-2" :href="`/get-pdv-details/${pdv.id}`"><img src="/img/icons/regresar.svg" alt="icon"></a>
                </div>
            </div>

            <div class="container mt-3">
                <div>
                    <div class="col-12 col-md-6">
                        <div class="header-portfolio d-flex flex-column">
                            <h5 class="text-title-bat mb-2">Transferencias</h5>
                        </div>
                    </div>
                </div>
                <div class="row content-profile" id="my-redemptions">
                    <div class="col-sm-12 col-md-12">
                        <div class="tabs">
                            <ul class="nav nav-pills mb-3">
                                <li class="nav-item" role="presentation">
                                    <button @click="changeTab('send')"
                                            :class="currentTab === 'send' ? 'active' : ''" class="nav-link" type="button"
                                            role="tab" aria-controls="pills-home"
                                            :aria-selected="currentTab === 'send'">Solicitadas</button>
                                </li>
                                <li class="nav-item" role="presentation">
                                    <button @click="changeTab('transfer')"
                                            :class="currentTab === 'transfer' ? 'active' : ''" class="nav-link" type="button"
                                            role="tab" aria-controls="pills-profile"
                                            :aria-selected="currentTab === 'transfer'">Recibidas
                                        <span v-if="notificationRequest" class="position-absolute  translate-middle rounded-circle bg-danger fs-8" style="width: 10px; height: 10px; margin-left: 20px !important;"></span>
                                    </button>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div v-if="paginatedData.length > 0" class="mt-2">
                    <div class="row justify-content-center p-1">
                        <div class="d-flex flex-wrap justify-content-start">
                            <div v-for="item in paginatedData" :key="item.id" class="col-lg-4 col-md-6 col-12 card-staff my-3 my-sm-1 px-3">
                                <div class="header">
                                    <div v-if="currentTab === 'send'">
                                        <span :class="{'pending-status-for-active-staff': item.type === 'send', 'pending-status-staff': item.type === 'request'}"></span>
                                        <span>
                                            {{ item.type === 'send' ? 'Transferencia en proceso' : 'Solicitud por aprobación' }}
                                        </span>
                                    </div>
                                    <div v-else>
                                        <span class="pending-status-staff"></span>
                                        <span>
                                            Solicitud por aprobación
                                        </span>
                                    </div>
                                </div>
                                <div class="">
                                    <div class="mt-2 text-bat" id="accordionTransfer">
                                        <el-collapse >
                                            <el-collapse-item :name="'pdv-' + item.id">
                                                <template #title>
                                                    <div class="transfer-title">
                                                        <div class="transfer-name">
                                                            <strong> {{ formatName(item.client.user.name) }} </strong>
                                                        </div>
                                                        <div class="transfer-identification mb-2">
                                                           Identificación: {{ item.identification_number}}
                                                        </div>
                                                    </div>
                                                </template>
                                                <div>
                                                    <p class="name-h6 my-2">Fecha de solicitud: {{ formatDate(item.created_at) }}</p>
                                                    <p  class="name-h6 m-0"><strong>Staff origen</strong></p>
                                                    <p class="name-h6 m-0">{{ formatName(item.pdv_origin.name_pdv) }}</p>
                                                    <p class="name-h6 m-0">{{ item.pdv_origin.address_pdv }}</p>
                                                    <p class="name-h6 mb-2">Código insitu {{ item.pdv_origin.insitu_code }}</p>
                                                    <p  class="name-h6 m-0"><strong>Staff destino</strong></p>
                                                    <p class="name-h6 m-0">{{ formatName(item.pdv_destination.name_pdv) }}</p>
                                                    <p class="name-h6 m-0">{{ item.pdv_destination.address_pdv }}</p>
                                                    <p class="name-h6 mb-2">Código insitu {{ item.pdv_destination.insitu_code }}</p>
                                                </div>
                                            </el-collapse-item>
                                        </el-collapse>
                                    </div>
                                </div>
                                <div>
                                    <div class="col-12" v-if="currentTab === 'send'">
                                        <a  @click="activeModalTransfer('cancel', item)" class="text-decoration-none">
                                            <button class="w-100" :class="{'btn': true, 'rounded-3': true, 'bg-transparent': true, 'p-2': true, 'px-3': true, 'mt-1': true, 'text-bat': true, 'align-items-center': true, 'btn-popups': true, 'text-indigo': true, 'fw-bold': true, 'd-block': true, 'd-md-inline-block': true}"
                                            >Anular transferencia</button>
                                        </a>
                                    </div>
                                    <div class="col-12" v-if="currentTab === 'transfer'">
                                        <a  @click="activeModalTransfer('approve', item)" class="text-decoration-none">
                                            <button class="w-100" :class="{'btn': true, 'rounded-3': true, 'bg-transparent': true, 'p-2': true, 'px-3': true, 'mt-1': true, 'text-bat': true, 'align-items-center': true, 'btn-popups': true, 'text-indigo': true, 'fw-bold': true, 'd-block': true, 'd-md-inline-block': true}"
                                            >Aceptar transferencia</button>
                                        </a>
                                    </div>
                                    <div class="col-12" v-if="currentTab === 'transfer'">
                                        <a  @click="activeModalTransfer('reject', item)" class="text-decoration-none">
                                            <button class="w-100" :class="{'btn': true, 'rounded-3': true, 'bg-transparent': true, 'p-2': true, 'px-3': true, 'mt-1': true, 'text-bat': true, 'align-items-center': true, 'btn-reject-request-transfer': true, 'fw-bold': true, 'd-block': true, 'd-md-inline-block': true}"
                                            >Rechazar</button>
                                        </a>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div class="row justify-content-center" v-if="totalPages > 1">
                        <div class="d-flex align-items-center justify-content-center">
                            <button @click="goToPage(currentPage - 1)" class="bg-transparent border-0" :disabled="currentPage === 1">
                                &lt;
                            </button>
                            <div class="text-bat">
                                <div v-if="visiblePages.length > 0">
                                    <span v-if="visiblePages[0] > 1">...</span>
                                    <span
                                        v-for="page in visiblePages"
                                        :key="page"
                                        @click="goToPage(page)"
                                        class="mx-3 mx-md-4 cursor-pointer"
                                        :class="{ 'text-title-bat text-orange': page === currentPage }">
                                        {{ page }}
                                    </span>
                                    <span v-if="visiblePages[visiblePages.length - 1] < totalPages">...</span>
                                </div>
                            </div>
                            <button @click="goToPage(currentPage + 1)" class="bg-transparent border-0"  :disabled="currentPage  === totalPages  || totalPages  === 0">
                                &gt;
                            </button>
                        </div>
                    </div>
                </div>
                <div v-else class="row">
                    <no-data-staff
                        :title="'¡Todo al día!'"
                        :description="'Tu Staff no tienes transferencias pendientes por ahora.'"
                    ></no-data-staff>
                </div>
            </div>

            <el-dialog :visible.sync="cancelTransfer" width="400px" class="filterDialogCatalog">
                <div class="modal-content">
                    <div class="row">
                        <div class="col-12">
                            <div class="d-flex flex-column align-items-center text-center">
                                <img src="/img-version2/icons/staff/dangerstaff.svg" alt="Icono" class="mb-2">
                                <h6 class="mx-auto" style="max-width: 268px;">Deseas anular la transferencia</h6>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12" style="padding: 10px 0!important;">
                            <div class="d-flex flex-column align-items-center text-center">
                                <button
                                    @click="actions('cancel', idTransfer.id)"
                                    :class="{'btn': true, 'rounded-3': true, 'bg-transparent': true, 'p-2': true, 'px-3': true, 'my-3': true, 'text-bat': true, 'align-items-center': true, 'btn-popups': true, 'text-indigo': true, 'fw-bold': true, 'd-block': true, 'd-md-inline-block': true, 'btn-staff': true}"
                                > Aceptar
                                </button>
                            </div>
                        </div>
                        <div class="col-12" style="padding: 10px 0!important;">
                            <div class="d-flex flex-column align-items-center text-center">
                                <div class="text-more cursor-pointer buttonOne" type="buttoNot"
                                     @click="resetModalTransfer('cancel')">Cancelar
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </el-dialog>
            <el-dialog :visible.sync="rejectTransfer" :width="getWidth()" class="filterDialogCatalog" @close="resetModalTransfer('reject')">
                <div class="modal-content">
                    <div class="row">
                        <div class="col-12">
                            <div class="d-flex flex-column align-items-center text-center">
                                <img src="/img-version2/icons/staff/user-remove-red.svg" alt="Icono" class="mb-2">
                                <h6 class="mx-auto" style="max-width: 268px;">Rechazo de transferencia</h6>
                                <p class="text-bat px-0">Por favor cuéntanos tu razón de rechazo de transferencia del staff.</p>
                            </div>
                        </div>
                        <div class="col-12">
                            <el-radio-group v-model="rejectReason" class="radio-group">
                                <el-radio label="1">No reconozco a esta persona</el-radio>
                                <el-radio label="2">Otra razón</el-radio>
                            </el-radio-group>
                        </div>
                        <div class="col-12" v-if="rejectReason == 2">
                            <div class="outlined-textarea mt-1">
                                <span class="outlined-label">Comentarios</span>

                                <el-input
                                    type="textarea"
                                    v-model="textRejectReason"
                                    placeholder="Escribe la razón de rechazo de transferencia"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12" style="padding: 10px 0!important;">
                            <div class="d-flex flex-column align-items-center text-center">
                                <button
                                    :disabled="validateSendRejectReason()"
                                    @click="actions('reject', idTransfer.id)"
                                    :class="{'btn-disabled-staff': validateSendRejectReason(), 'btn': true, 'rounded-3': true, 'bg-transparent': true, 'p-2': true, 'px-3': true, 'my-3': true, 'text-bat': true, 'align-items-center': true, 'btn-popups': true, 'text-indigo': true, 'fw-bold': true, 'd-block': true, 'd-md-inline-block': true, 'btn-staff': true}"
                                > Enviar respuesta
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </el-dialog>
            <el-dialog :visible.sync="approveTransfer" :width="getWidth()" class="filterDialogCatalog" >
                <div class="modal-content">
                    <div class="row">
                        <div class="col-12">
                            <div class="d-flex flex-column align-items-center text-center">
                                <img src="/img-version2/icons/staff/tick-circle-complete.svg" alt="Icono" class="mb-2">
                                <h6 class="mx-auto" style="max-width: 268px;">Has confirmado la transferencia</h6>
                                <p class="text-bat px-0">El usuario {{ idTransfer !== null ? formatName(idTransfer.client?.user?.name) : '' }} será transferido al staff.</p>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12" style="padding: 10px 0!important;">
                            <div class="d-flex flex-column align-items-center text-center">
                                <button
                                    @click="resetModalTransfer('approve', idTransfer.id)"
                                    :class="{'btn': true, 'rounded-3': true, 'bg-transparent': true, 'p-2': true, 'px-3': true, 'my-3': true, 'text-bat': true, 'align-items-center': true, 'btn-popups': true, 'text-indigo': true, 'fw-bold': true, 'd-block': true, 'd-md-inline-block': true, 'btn-staff': true}"
                                > Aceptar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </el-dialog>
        </div>
    </div>

</template>

<script>

import {EventBus} from "../../app";

export default {
    props:{
        pdv: {
            default: null
        },
        admin_staff_segments: {
            default: [],
        },
        type: {
            default: 'send',
        }
    },
    data() {
        return {
            loading: 0,
            pdvs: [],
            selectedPdv: null,
            client: [],
            combinateData: null,
            getWidth() {
                if (this.$mq === 'sm') {
                    return '95%';
                } else if (this.$mq === 'md') {
                    return '35%';
                } else if (this.$mq === 'lg') {
                    return '30%';
                } else {
                    return '20%';
                }
            },
            currentPage: 1,
            itemsPerPage: 15,
            maxVisiblePages: 5,
            currentTab: 'send', //received
            idTransfer: null,
            cancelTransfer: false,
            rejectTransfer: false,
            rejectReason: null,
            textRejectReason: '',
            approveTransfer: false,
            notificationRequest: false,
        };
    },
    mounted() {
        this.currentTab = this.type;
        this.validateRequestsToMe();
        this.getData();
    },
    computed: {
        paginatedData() {
            if (!Array.isArray(this.combinateData)) {
                return [];
            }
            const start = (this.currentPage - 1) * this.itemsPerPage;
            const end = start + this.itemsPerPage;
            return this.combinateData.slice(start, end);
        },
        visiblePages() {
            const pages = [];
            const half = Math.floor(this.maxVisiblePages / 2);
            let start = Math.max(1, this.currentPage - half);
            let end = Math.min(this.totalPages, start + this.maxVisiblePages - 1);

            if (end - start < this.maxVisiblePages - 1) {
                start = Math.max(1, end - this.maxVisiblePages + 1);
            }

            for (let i = start; i <= end; i++) {
                pages.push(i);
            }

            return pages;
        },
        totalPages() {
            return Math.ceil(this.combinateData.length / this.itemsPerPage);
        },
    },
    methods: {
        changeTab(tab){
            this.combinateData = null;
            this.currentTab = tab;
            this.validateRequestsToMe();
            this.getData();
        },
        getData(){
            const url = (this.currentTab === 'send') ? `/get-my-requests-transfer?insitu_code=${this.pdv.insitu_code}` : `/get-request-transfer-to-me?insitu_code=${this.pdv.insitu_code}`;
            axios.get(url)
                .then((response) => {
                    const request = response.data.requests ?? [];
                    let my_request = response.data.my_requests ?? [];
                    if(this.currentTab !== 'send'){
                        my_request = response.data.requests_to_me ?? [];
                    }
                    const allRequests = [...request, ...my_request];
                    allRequests.sort((a, b) => a.id - b.id);
                    this.combinateData = allRequests;
                    console.log(this.combinateData);
                }).catch(error => {
                    console.log(error);
            });
        },
        cancelRequest(identificationNumber, selectedPdv) {
            axios.post(`/cancel-request-pdv/${this.selectedPdv}`, {
                identification_number: identificationNumber
            })
                .then(response => {
                })
                .catch(error => {
                    console.error("Error al cancelar la solicitud", error.response ? error.response.data : error);
                });
        },
        goToPage(page) {
            if (page >= 1 && page <= this.totalPages) {
                this.currentPage = page;
            }
        },
        formatName(name) {
            let nameParts = name.split(' ').map(part => {
                return part.charAt(0).toUpperCase() + part.slice(1).toLowerCase();
            });

            return nameParts.join(' ');
        },
        formatDate(date) {
            const d = new Date(date);
            return `${d.getDate()}/${d.getMonth() + 1}/${d.getFullYear()}`;
        },
        validateRequestsToMe(){
            axios.get(`/get-request-transfer-to-me?insitu_code=${this.pdv.insitu_code}`)
                .then((response) => {
                    const request = response.data.requests ?? [];
                    let my_request = response.data.requests_to_me ?? [];
                    const total = [...request, ...my_request];
                    this.notificationRequest = total.length > 0;
                }).catch(error => {
                console.log(error);
            });
        },
        activeModalTransfer(type,id){
            this.idTransfer = id;
            if(type === 'cancel'){
               this.cancelTransfer = true;
            }else if(type === 'reject'){
                this.rejectTransfer = true;
            }else if(type === 'approve'){
                this.actions('approve', id.id);
            }
        },
        resetModalTransfer(type){
            this.idTransfer = null;
            if(type === 'cancel'){
                this.cancelTransfer = false;
            }else if(type === 'reject'){
                this.rejectTransfer = false;
                this.rejectReason = null;
                this.textRejectReason = '';
            }else if(type === 'approve'){
                this.approveTransfer = false;
                this.changeTab(this.currentTab);
            }

        },
        validateSendRejectReason(){
          if(this.rejectReason === null){
              return true;
          }else if(this.rejectReason == 1){
              return false;
          }else if(this.rejectReason == 2 && this.textRejectReason === ''){
              return true;
          }else if(this.rejectReason == 2 && this.textRejectReason !== ''){
              return false;
          }
        },
        actions(type, id){
            let url = '';
            let data = {
                request_transfer_id: id,
            };
            if(type === 'cancel'){
                url = '/cancel-request-transfer';
                data.reject_reason = this.rejectReason ?? 'anular';
            }else if(type === 'reject'){
                url = '/reject-request-transfer';
                data.reject_reason = this.rejectReason == 1 ? 'No reconozco a esta persona' : this.textRejectReason;
            }else if(type === 'approve'){
                url = '/approve-request-transfer';
            }

            axios.post(url, data)
                .then((response) => {
                    if(type !== 'approve'){
                        if(response.status === 201){
                            this.resetModalTransfer(type);
                            this.changeTab(this.currentTab);
                        }
                    }else{
                        this.approveTransfer = true;
                    }
                }).catch((error) =>{
                console.log(error)
            });
        }
    }
};
</script>
